exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3UYT_{background-color:#383838;height:98px;width:100%;color:#999;left:0}._2oTVh{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;max-width:970px}._3G-Lp{padding-top:20px}._3G-Lp li{line-height:15px;font-weight:300}._3Rs7t{padding:0 5px}._3Rs7t,._3Rs7t:active,._3Rs7t:hover,._3Rs7t:visited{color:#999}._3avzK{padding-top:8%}._3avzK img{width:102px;height:50px}._3avzK img:first-child{padding-right:18px}", ""]);

// exports
exports.locals = {
	"root": "_3UYT_",
	"container": "_2oTVh",
	"text": "_3G-Lp",
	"link": "_3Rs7t",
	"logos": "_3avzK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/LegalGroup/LegalGroup.css
// module id = 1050
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13